export const adminPaths = {
  dashboard: "/admin-panel",
  discover: "/discover",
  map: "/map",
  businesses: "/businesses",
  profile: "/profile",
  bookings: "/bookings",
  payments: "/payments",
  saved: "/saved",
  alerts: "/alerts",
  content: {
    provinces: {
      list: "/content/provinces",
      create: "/content/provinces/new",
      edit: (id = ":id") => `/content/provinces/${id}`,
      detail: (id = ":id") => `/provinces/${id}`,
    },
    deals: {
      list: "/content/deals",
      create: "/content/deals/new",
      edit: (id = ":id") => `/content/deals/${id}`,
      detail: (id = ":id") => `/deals/${id}`,
    },
    ads: {
      list: "/content/ads",
      create: "/content/ads/new",
      edit: (id = ":id") => `/content/ads/${id}`,
    },
    mobileCms: {
      list: "/content/mobile-cms",
      planCreate: "/content/mobile-cms/plans/new",
      planEdit: (id = ":id") => `/content/mobile-cms/plans/${id}`,
      travelCreate: (kind = ":kind") => `/content/mobile-cms/${kind}/new`,
      travelEdit: (kind = ":kind", id = ":id") => `/content/mobile-cms/${kind}/${id}`,
    },
    legal: {
      list: "/content/legal",
      create: "/content/legal/new",
      edit: (id = ":id") => `/content/legal/${id}`,
    },
    sitePages: {
      list: "/content/site-pages",
      create: "/content/site-pages/new",
      edit: (id = ":id") => `/content/site-pages/${id}`,
    },
  },
  partner: {
    home: "/partner",
    bookings: "/partner/bookings",
    businesses: "/partner/businesses",
    createBusiness: "/partner/businesses/new",
    editBusiness: (id = ":id") => `/partner/businesses/${id}`,
  },
  admin: {
    home: "/admin-panel",
    businesses: "/admin-panel/businesses",
    createBusiness: "/admin-panel/businesses/new",
    editBusiness: (id = ":id") => `/admin-panel/businesses/${id}`,
    bookings: "/admin-panel/bookings",
    bookingDetail: (id = ":id") => `/admin-panel/bookings/${id}`,
    subscriptions: "/admin-panel/subscriptions",
    subscriptionDetail: (id = ":id") => `/admin-panel/subscriptions/${id}`,
    users: "/admin-panel/users",
    userDetail: (id = ":id") => `/admin-panel/users/${id}`,
    alerts: "/admin-panel/alerts",
    notifications: "/admin-panel/notifications",
    kadekon: "/admin-panel/kadekon",
    applications: "/admin-panel/applications",
    listingInquiries: "/admin-panel/listing-inquiries",
    favorites: "/admin-panel/favorites",
    supportRequests: "/admin-panel/support-requests",
  },
};

export const adminRoutePlan = [
  {
    module: "content",
    entities: [
      { key: "provinces", list: adminPaths.content.provinces.list, create: adminPaths.content.provinces.create, edit: adminPaths.content.provinces.edit() },
      { key: "deals", list: adminPaths.content.deals.list, create: adminPaths.content.deals.create, edit: adminPaths.content.deals.edit() },
      { key: "ads", list: adminPaths.content.ads.list, create: adminPaths.content.ads.create, edit: adminPaths.content.ads.edit() },
      { key: "mobileCms", list: adminPaths.content.mobileCms.list },
      { key: "legal", list: adminPaths.content.legal.list, create: adminPaths.content.legal.create, edit: adminPaths.content.legal.edit() },
      { key: "sitePages", list: adminPaths.content.sitePages.list, create: adminPaths.content.sitePages.create, edit: adminPaths.content.sitePages.edit() },
    ],
  },
  {
    module: "admin",
    entities: [
      { key: "businesses", list: adminPaths.admin.businesses, create: adminPaths.admin.createBusiness, edit: adminPaths.admin.editBusiness() },
      { key: "bookings", list: adminPaths.admin.bookings, detail: adminPaths.admin.bookingDetail() },
      { key: "subscriptions", list: adminPaths.admin.subscriptions, detail: adminPaths.admin.subscriptionDetail() },
      { key: "users", list: adminPaths.admin.users, detail: adminPaths.admin.userDetail() },
      { key: "alerts", list: adminPaths.admin.alerts },
      { key: "notifications", list: adminPaths.admin.notifications },
      { key: "kadekon", list: adminPaths.admin.kadekon },
      { key: "applications", list: adminPaths.admin.applications },
      { key: "listingInquiries", list: adminPaths.admin.listingInquiries },
      { key: "favorites", list: adminPaths.admin.favorites },
      { key: "supportRequests", list: adminPaths.admin.supportRequests },
    ],
  },
];
